import { render, staticRenderFns } from "./RaceEventList.vue?vue&type=template&id=48e8e9c5&"
import script from "./RaceEventList.vue?vue&type=script&lang=js&"
export * from "./RaceEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports